import wellcome from "./wellcome"
import marketplace from "./marketplace"

export default {
  0: marketplace,
  15: wellcome
}
